import React, { useRef, useState, useEffect } from "react";
import moment from "moment";
import axios from '../../../plugins/axios'

const Wave = ({alarmWaves,startTime,serialNo}) => {
    const canvasRef = useRef(null);
    const [waves, setWaves] = useState({});

    const CANVAS_WIDTH = 3201;
    const CANVAS_HEIGHT = 1526; // 캔버스 전체 높이    
    const GRID_SIZE = 25;

    //100 height가 1mV

    // Wave 데이터 가져오기
    const getWaveData = async () => {
        try{
            const totalWave = [];
            const waves = alarmWaves.map(w => w.measureParameter);

            for (const wave of waves) {                
                const waveRes = await axios.get(`/trend/waveforms?serialNo=${serialNo}&type=${wave}&startTime=${moment.utc(startTime).format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment.utc(startTime).add(30, 'seconds').format('YYYY-MM-DDTHH:mm:ss')}Z`);
                const fillwave = setTrendWaveList(
                    waveRes.data.waveformData.waveforms,
                    wave,
                    moment.utc(startTime).format('YYYY-MM-DDTHH:mm:ss'),
                    moment.utc(startTime).add(30, 'seconds').format('YYYY-MM-DDTHH:mm:ss')
                );                               
                totalWave.push({[wave]: fillwave});
            }

            console.log('totalWave', totalWave);
            setWaves(totalWave);
        }
        catch(err){
            console.warn('[getWaveData] err', err);
        }
    }

    //moment로 보내서 moment.utc로 묶어서 09:00을 +시켜버리는 작업을 하였음.
    const setTrendWaveList = (data,trendWaveType, startTime, endTime) => {
        // 시작 시간과 끝 시간을 moment로 변환
        const start = moment.utc(startTime).startOf("second");
        const end = moment.utc(endTime).startOf("second");       
    
        // 시작 시간부터 끝 시간까지 초 단위로 빈 데이터 생성
        const allSeconds = [];
        let current = start.clone();
        while (current < end) {
            allSeconds.push(current.format());
            current.add(1, "second");
        }
    
        // 실제 데이터를 Timestamp : value 형태로 변환
        const groupedBySecond = data.reduce((acc, item) => {
            const secondKey = moment.utc(item.timestamp).startOf("second").format();  
            acc[secondKey] = item.samples || [];
            return acc;
        }, {});           

        const completeResult = allSeconds
        .map((second) => ({
            type : trendWaveType,
            createdAt: second,
            wave: groupedBySecond[second] || [], // 데이터가 없으면 빈 배열
        }));         

        return completeResult;
    };

    // Canvas에 그리드 그리기
    const drawGrid = (ctx) => {
        ctx.strokeStyle = "#FF8383";
        ctx.lineWidth = 1;
        ctx.translate(0.5, 0.5);

        // 일반 그리드 세로선
        for (let x = 0; x <= CANVAS_WIDTH; x += GRID_SIZE) {
            ctx.beginPath();
            ctx.moveTo(x, 0);
            ctx.lineTo(x, CANVAS_HEIGHT - 1);
            ctx.stroke();
        }

        // 가로선
        ctx.strokeStyle = "#FF8383";
        ctx.lineWidth = 1;
        for (let y = 0; y < CANVAS_HEIGHT; y += GRID_SIZE) {
            ctx.beginPath();
            ctx.moveTo(0, y);
            ctx.lineTo(CANVAS_WIDTH - 1, y);
            ctx.stroke();
        }

        // 맨 아래 선 추가 (박스 하단)
        ctx.beginPath();
        ctx.moveTo(0, CANVAS_HEIGHT - 1);
        ctx.lineTo(CANVAS_WIDTH - 1, CANVAS_HEIGHT - 1);
        ctx.stroke();

        // 맨 마지막 세로선 추가
        ctx.beginPath();
        ctx.moveTo(CANVAS_WIDTH, 0);
        ctx.lineTo(CANVAS_WIDTH, CANVAS_HEIGHT - 1); // 캔버스 하단까지
        ctx.stroke();

        // === 시간 마커 및 텍스트 추가 ===
        const markerTop = 0; // 마커 시작 y
        const markerHeight = 16; // 마커 세로 길이
        const textOffsetY = markerTop + markerHeight + 16; // 텍스트 y 위치 (마커 아래 16px)
        const duration = 30; // 30초
        const interval = 5; // 5초 단위
        const totalWidth = CANVAS_WIDTH;
        const startMoment = moment(startTime);
        ctx.font = "300 24px Pretendard, sans-serif";
        ctx.fillStyle = "#444";
        ctx.textAlign = "center";
        ctx.textBaseline = "top";

        for (let sec = 0; sec <= duration; sec += interval) {
            let x = Math.round((sec / duration) * totalWidth);

            // 처음과 마지막 마커는 0.5px 보정
            if (sec === 0) x = 0.5;
            if (sec === duration) x = totalWidth - 1.5; // 여기!

            ctx.save();
            ctx.strokeStyle = "#FF8383";
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(x, markerTop); 
            ctx.lineTo(x, markerTop + markerHeight);
            ctx.stroke();
            ctx.restore();

            // 시간 텍스트
            const timeStr = startMoment.clone().add(sec, "seconds").format("HH:mm:ss");
            if (sec === 0) {
                ctx.textAlign = "left";
            } else if (sec === duration) {
                ctx.textAlign = "right";
            } else {
                ctx.textAlign = "center";
            }
            ctx.fillText(timeStr, x, markerTop + markerHeight + 2);
        }

        ctx.translate(-0.5, -0.5);
    };
    
    // 웨이브폼 그리기
    const drawWaveform = (ctx, waveData, index = 0) => {
        // 설정값
        const WAVE_NAME_HEIGHT = 50;
        const WAVE_HEIGHT = 150; // 실제 웨이브 그릴 영역
        const WAVE_MARGIN_TOP = 125;
        const WAVE_MARGIN_BOTTOM = 175;
        const MV_BOX_WIDTH = 14;
        const MV_BOX_HEIGHT = 100;
        const MV_BOX_LEFT = 10;

        // 웨이브 그릴 시작 y좌표 계산
        const waveStartY = WAVE_MARGIN_TOP + index * (WAVE_NAME_HEIGHT + WAVE_HEIGHT + WAVE_MARGIN_BOTTOM);

        // 1. 웨이브 이름 표기
        ctx.save();
        ctx.font = "500 32px Pretendard, sans-serif";
        ctx.fillStyle = "#000";
        ctx.textAlign = "left";
        ctx.textBaseline = "top";
        ctx.fillText(waveData[0]?.type || "WAVE", 28, waveStartY + 10);
        ctx.restore();

        //해당 데이터들만 1mV or 1Ω 박스 그림.
        if(['LEADⅠ', 'LEADⅡ', 'LEADⅢ', 'RR', 'RESP'].indexOf(waveData[0]?.type) !== -1){
            // 2. 1mV 박스 그리기 (투명도 0.2)
            ctx.save();
            ctx.globalAlpha = 0.2;
            ctx.fillStyle = "#000";
            ctx.fillRect(MV_BOX_LEFT, waveStartY + WAVE_NAME_HEIGHT + (WAVE_HEIGHT - MV_BOX_HEIGHT) / 2, MV_BOX_WIDTH, MV_BOX_HEIGHT);
            ctx.globalAlpha = 1.0;
            ctx.restore();

            // 3. 1mV 텍스트 표기
            const text = ['LEADⅠ', 'LEADⅡ', 'LEADⅢ'].indexOf(waveData[0]?.type) !== -1 ? '1mv' : '1Ω'

            ctx.save();
            ctx.font = "400 28px Pretendard, sans-serif";
            ctx.fillStyle = "#9F9F9F";
            ctx.textAlign = "left";
            ctx.textBaseline = "bottom";
            ctx.fillText(text, MV_BOX_LEFT + MV_BOX_WIDTH + 6, waveStartY + WAVE_NAME_HEIGHT + (WAVE_HEIGHT - MV_BOX_HEIGHT) / 2 + MV_BOX_HEIGHT);
            ctx.restore();
        }

        // 4. 웨이브 그리기
        ctx.save();
        ctx.strokeStyle = "#000";
        ctx.lineWidth = 2;

        // 웨이브 데이터 펼치기
        const samples = [];
        waveData.forEach(item => {
            if (Array.isArray(item.wave)) samples.push(...item.wave);
        });

        if (!samples.length) {
            ctx.restore();
            return;
        }

        // 샘플값의 최대/최소 구하기
        const defaultMinY = -150
        const defaultMaxY = 300
        let max = Math.max(...samples.filter(v => v !== null && v !== undefined));
        let min = Math.min(...samples.filter(v => v !== null && v !== undefined));
        min = Math.min(min, defaultMinY)
        max = Math.max(max, defaultMaxY)
        const amplitude = Math.max(Math.abs(max), Math.abs(min), 1); // 0 방지

        // 중앙선 기준        
        const centerY = waveStartY + WAVE_NAME_HEIGHT + WAVE_HEIGHT / 2;
        const xStep = CANVAS_WIDTH / Math.max(samples.length - 1, 1);

        let currentPath = null;
        for (let i = 0; i < samples.length; i++) {
            const x = i * xStep;
            const value = samples[i];
            if (value !== null && value !== undefined) {
                // 정규화: 중앙 기준 WAVE_HEIGHT/2 내로
                let yOffset = (value / amplitude) * (WAVE_HEIGHT / 2 - 1);
                const y = centerY - yOffset;

                if (currentPath === null) {
                    ctx.beginPath();
                    ctx.moveTo(x, y);
                    currentPath = true;
                } else {
                    ctx.lineTo(x, y);
                }
            } else {
                if (currentPath !== null) {
                    ctx.stroke();
                    currentPath = null;
                }
            }
        }
        if (currentPath !== null) {
            ctx.stroke();
        }
        ctx.restore();

        // 5. 마지막 웨이브는 하단 여백 75px, 나머지는 150px
        // (별도 처리 필요시 index와 전체 웨이브 개수 활용)
    } 

    // wave 데이터 가져오기    
    useEffect(() => {
        getWaveData();
    }, []);

    // Canvas 렌더링
    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        //데이터 없으면 리턴
        if(!waves) return;


        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);

        // 그리드 그리기
        drawGrid(ctx);

        // 데이터 전처리 후 웨이브폼 그리기
        if (waves && Array.isArray(waves) && waves.length > 0) {            
            waves.forEach((waveObj, idx) => {
                // waveObj는 {waveType: data} 구조이므로, value만 추출
                const waveData = Object.values(waveObj)[0];
                drawWaveform(ctx, waveData, idx);
            });
        }   
    }, [waves]);

    return (
        <div className="flex flex-col items-center justify-center">
            <canvas
                ref={canvasRef}
                width={CANVAS_WIDTH}
                height={CANVAS_HEIGHT}
                className="block"
            />
        </div>
    )
}

export default Wave